var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog dialog-fixed-height",
      attrs: {
        title: "支付通道编辑",
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c("div", { staticClass: "form-section-title" }, [
            _vm._v("配置信息"),
          ]),
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "channel-form",
              attrs: {
                model: _setup.localForm,
                rules: _setup.formRules,
                "label-position": "right",
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "通道名称", prop: "channel_name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      placeholder: "请输入通道名称",
                      maxlength: "100",
                      "show-word-limit": "",
                      disabled: "",
                    },
                    model: {
                      value: _setup.localForm.channel_name,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "channel_name", $$v)
                      },
                      expression: "localForm.channel_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "支持币种", prop: "currency" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "140px" },
                    attrs: { disabled: "", value: _setup.localForm.currency },
                  }),
                ],
                1
              ),
              _setup.channelType === "payin"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "单笔限额", prop: "limit_min" } },
                    [
                      _c(
                        "span",
                        { staticClass: "limit-inputs" },
                        [
                          _c("el-input-number", {
                            staticClass: "input-number-sm",
                            attrs: {
                              min: 0,
                              controls: false,
                              placeholder: "最小",
                            },
                            model: {
                              value: _setup.localForm.payin_min_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.localForm,
                                  "payin_min_amount",
                                  $$v
                                )
                              },
                              expression: "localForm.payin_min_amount",
                            },
                          }),
                          _c("span", { staticClass: "limit-sep" }, [
                            _vm._v("-"),
                          ]),
                          _c("el-input-number", {
                            staticClass: "input-number-sm",
                            attrs: {
                              min: 0,
                              controls: false,
                              placeholder: "最大",
                            },
                            model: {
                              value: _setup.localForm.payin_max_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.localForm,
                                  "payin_max_amount",
                                  $$v
                                )
                              },
                              expression: "localForm.payin_max_amount",
                            },
                          }),
                          _c("span", { staticClass: "form-unit" }, [
                            _vm._v(_vm._s(_setup.localForm.currency)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _setup.channelType === "payout"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "单笔限额", prop: "limit_min" } },
                    [
                      _c(
                        "span",
                        { staticClass: "limit-inputs" },
                        [
                          _c("el-input-number", {
                            staticClass: "input-number-sm",
                            attrs: {
                              min: 0,
                              controls: false,
                              placeholder: "最小",
                            },
                            model: {
                              value: _setup.localForm.payout_min_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.localForm,
                                  "payout_min_amount",
                                  $$v
                                )
                              },
                              expression: "localForm.payout_min_amount",
                            },
                          }),
                          _c("span", { staticClass: "limit-sep" }, [
                            _vm._v("-"),
                          ]),
                          _c("el-input-number", {
                            staticClass: "input-number-sm",
                            attrs: {
                              min: 0,
                              controls: false,
                              placeholder: "最大",
                            },
                            model: {
                              value: _setup.localForm.payout_max_amount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.localForm,
                                  "payout_max_amount",
                                  $$v
                                )
                              },
                              expression: "localForm.payout_max_amount",
                            },
                          }),
                          _c("span", { staticClass: "form-unit" }, [
                            _vm._v(_vm._s(_setup.localForm.currency)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _setup.channelType === "payin"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "充值手续费", prop: "payin_fee_rate" } },
                    [
                      _c("el-input", {
                        staticClass: "input-number-sm",
                        attrs: { controls: false, disabled: "" },
                        model: {
                          value: _setup.localForm.payin_fee_rate,
                          callback: function ($$v) {
                            _vm.$set(_setup.localForm, "payin_fee_rate", $$v)
                          },
                          expression: "localForm.payin_fee_rate",
                        },
                      }),
                      _c("span", { staticClass: "form-unit" }, [_vm._v("%")]),
                    ],
                    1
                  )
                : _vm._e(),
              _setup.channelType === "payout"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "提现手续费", prop: "payout_fee_rate" } },
                    [
                      _c("el-input-number", {
                        staticClass: "input-number-sm",
                        attrs: { controls: false, disabled: "" },
                        model: {
                          value: _setup.localForm.payout_fee_rate,
                          callback: function ($$v) {
                            _vm.$set(_setup.localForm, "payout_fee_rate", $$v)
                          },
                          expression: "localForm.payout_fee_rate",
                        },
                      }),
                      _c("span", { staticClass: "form-unit" }, [_vm._v("%")]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "权重", prop: "weight" } },
                [
                  _c("el-input-number", {
                    staticClass: "input-number-sm",
                    attrs: {
                      min: 0,
                      controls: false,
                      placeholder: "0",
                      step: 1,
                      "step-strictly": "",
                    },
                    model: {
                      value: _setup.localForm.weight,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "weight", $$v)
                      },
                      expression: "localForm.weight",
                    },
                  }),
                  _c("span", { staticClass: "form-hint" }, [
                    _vm._v("数字越大权重越高"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localForm.status,
                        callback: function ($$v) {
                          _vm.$set(_setup.localForm, "status", $$v)
                        },
                        expression: "localForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("停用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _setup.channelType === "payin"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-vips",
                      attrs: { label: "适用对象", prop: "vips" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "vips-wrap" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { value: _setup.isAllVipChecked },
                              on: { change: _setup.handleAllVipChange },
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "vips-group",
                              model: {
                                value: _setup.localForm.vips,
                                callback: function ($$v) {
                                  _vm.$set(_setup.localForm, "vips", $$v)
                                },
                                expression: "localForm.vips",
                              },
                            },
                            _vm._l(_setup.vipOptions, function (item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息", prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _setup.localForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "remark", $$v)
                      },
                      expression: "localForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }